import {
  OPERATION_MIN_VALUES,
  TOperation
} from "@saleor/discounts/hooks/useVoucherLimitsData";

export enum ConditionsTypeEnum {
  EXACTLY = "EQ",
  MORE_THAN = "GT",
  LESS_THAN = "LT",
  AT_LEAST = "GE",
  AT_MOST = "LE"
}

export const CONDITIONS_CHOICES = [
  {
    label: "Exactly",
    value: ConditionsTypeEnum.EXACTLY
  },
  {
    label: "More than",
    value: ConditionsTypeEnum.MORE_THAN
  },
  {
    label: "Less than",
    value: ConditionsTypeEnum.LESS_THAN
  },
  {
    label: "At least",
    value: ConditionsTypeEnum.AT_LEAST
  },
  {
    label: "At most",
    value: ConditionsTypeEnum.AT_MOST
  }
];

export const generateMinNumberProps = (condition: TOperation) => {
  switch (condition) {
    case "EQ":
      return {
        min: OPERATION_MIN_VALUES.EQ
      };
    case "GE":
      return {
        min: OPERATION_MIN_VALUES.GE
      };
    case "GT":
      return {
        min: OPERATION_MIN_VALUES.GT
      };
    case "LE":
      return {
        min: OPERATION_MIN_VALUES.LE
      };
    case "LT":
      return {
        min: OPERATION_MIN_VALUES.LT
      };
  }
};
